import axios from '../axiosConfig';

var deployPath = process.env.REACT_APP_SERVER_URL || "";

export default {  
  login: (request) => {
    return axios.post(`${deployPath}/api/client/login`, request)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      // console.log(error);
    });
  },

  getClientByMail: (email) => {
    return axios.get(`${deployPath}/api/client/getByMail/${email}`)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      // console.log(error);
    });
  },

  sendPolicyDocuments: (request) => {
    return axios.post(`${deployPath}/api/client/sendPolicyDocuments`, request)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      // console.log(error);
    });
  },

  sendQuoteByEmail: (request) => {
    return axios.post(`${deployPath}/api/client/sendQuoteByEmail/`, request)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        // console.log(error);
      });
  },

  registerClient: (request) => {
    return axios.post(`${deployPath}/api/client/register`, request)
    .then(response => {
      return response.data
    })
    .catch(error => {
      // console.log(error);
    });
  },

  sendPolicyByMail: ({tipoDoc, nroDoc}) => {
    return axios.get(`${deployPath}/api/client/sendPolicyByMail/${tipoDoc}/${nroDoc}`)
    .then(response => {
      return response.data
    })
    .catch(error => {
      // console.log(error);
    });
  },

  validateToken: (request) => {
    return axios.post(`${deployPath}/api/client/validateToken`, request)
    .then(response => {
      return response.data
    })
    .catch(error => {
      // console.log(error);
    });
  },

  forgotPassword: (request) => {
    return axios.post(`${deployPath}/api/client/forgotPassword`, request)
    .then(response => {
      return response.data
    })
    .catch(error => {
      // console.log(error);
    });
  },

  changePassword: (request) => {
    return axios.post(`${deployPath}/api/client/resetPassword`, request)
    .then(response => {
      return response.data
    })
    .catch(error => {
      // console.log(error);
    });
  },
};